/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Upgrade_DescriptionInputs */



/**
* | output |
* | --- |
* | "Review the changes before confirming." |
*
* @param {Sub_Upgrade_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_upgrade_description = /** @type {((inputs?: Sub_Upgrade_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Upgrade_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überprüfen Sie die Änderungen vor der Bestätigung.")
	return /** @type {LocalizedString} */ ("Review the changes before confirming.")
});